import styled from 'styled-components';

const Wrapper = styled.div`
  height: ${(props) =>
    props?.fullHeight ? 'calc(100% - 10px)' : 'calc(100% - 60px)'};
  overflow: scroll;

  table {
    border-collapse: separate;
  }

  .noDataWrapper {
    margin: auto;
  }

  tbody {
    tr:not(.grpHeaderRow, .emptyRow) {
      &.loading {
        opacity: 0.6;
        cursor: not-allowed;
        pointer-events: none;
        transition: all 0.4s;
      }
      &:hover {
        background: #f5f5fc;
      }
    }
  }
  td {
    height: 50px;
    padding-left: 20px;
  }

  thead th {
    position: sticky;
    top: 0;
    font-size: 12px;
    font-weight: 500;
    padding-left: 20px;
    background: white;
    min-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-bottom: 1px solid #dedede;
    border-radius: 0;
    z-index: 1;
    &:not(:last-child):after {
      border-right: 1px solid #dedede;
      content: '';
      height: 40%;
      background: white;
      position: absolute;
      right: 0;
      top: 15px;
    }
  }
`;

const Tr = styled.tr`
  background: #f9f9ff;
  position: sticky;
  z-index: 1;
  &:after,
  &:before {
    background: #f9f9ff;
  }
  top: 51px;
  .grpHeader {
    font-size: 15px;
    font-weight: 600;
    height: 30px;
    padding-left: 20px;
    position: sticky;
    text-transform: none;
  }
`;

export { Wrapper, Tr };
